import companyService from "@/services/company";
import serviceHandler from "@/helpers/handlers/service";
import { mapState } from "vuex";

import cuid from "cuid";

export default {
  name: "SocialMediaAuditData",
  data() {
    return {
      data: []
    };
  },
  computed: {
    ...mapState({
      companyId: state => state.company.id,
      isInstagramSet: state => !!state.company.company.instagram_url,
      isFacebookSet: state => !!state.company.company.facebook_url
    })
  },

  async created() {
    await this.fetchSocialMediaAudit();
  },

  methods: {
    async fetchSocialMediaAudit() {
      const [facebook, instagram] = await Promise.all([
        serviceHandler(companyService.getLastFacebookAudit(this.companyId)),
        serviceHandler(companyService.getLastInstagramAudit(this.companyId))
      ]);

      this.data = [
        {
          name: "facebook",
          id: cuid(),
          audit: facebook,
          isSet: this.isFacebookSet,
          info: this.$t("message.visibility.socialMedia.facebook.rate")
        },
        {
          name: "instagram",
          id: cuid(),
          audit: instagram,
          isSet: this.isInstagramSet,
          info: this.$t("message.visibility.socialMedia.instagram.rate")
        }
      ];
    }
  },

  render() {
    return this.$scopedSlots.default({
      data: this.data
    });
  }
};
